import AbouttheAuthor from '../../sections/home/AuthorBio';
// import NextBookPreview from '../../sections/home/NextBookPreview';
import NextBookSection from '../../sections/home/NextBookSection';
import LatestBookSection from '../../sections/home/LatestBookSection';
import BooksCarousel from '../../sections/home/BooksCarousel';

import Newssection from '../../sections/home/NewsPreview';
import HomePromo from '../../sections/home/HomePromo';
import Reviews from '../../sections/home/Reviews';

// Add new sections here, then control order + visibility below.
export const homeSections = [
  {
    id: 'about',
    label: 'About the Author',
    enabled: true,
    Component: AbouttheAuthor,
  },
  {
    id: 'nextRelease',
    label: 'Coming Soon',
    enabled: true,
    Component: NextBookSection,
  },
  {
    id: 'release',
    label: 'New Release',
    enabled: true,
    Component: LatestBookSection,
  },
  {
    id: 'promo',
    label: 'Homepage Promo',
    enabled: true, // flip to false when not wanted
    Component: HomePromo,
  },
  {
    id: 'news',
    label: 'News',
    enabled: true,
    Component: Newssection,
  },
  {
    id: 'booksCarousel',
    label: 'Slideshow',
    enabled: true,
    Component: BooksCarousel,
  },
  {
    id: 'reviews',
    label: 'Reviews',
    enabled: true,
    Component: Reviews,
  },
];
